import { HttpClient } from '@angular/common/http';
import { Component, OnInit, } from '@angular/core';
import { DashboardData } from '../../models/dashboard.model';
import { Route, Router, RouterModule } from '@angular/router';
import { QuestionnaireAvailability, QuestionnaireService } from '../../service/questionnaire.service';
import { AlertService } from '../../service/alert.service';
import { environment } from '../../environments/environment';
import { MatSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertMessageComponent } from '../../shared/alert-message/alert-message.component';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  imports: [CommonModule, MatProgressSpinnerModule, MatIconModule, MatTooltipModule, RouterModule, AlertMessageComponent, TranslateModule]
})
export class DashboardComponent implements OnInit {

  dashboardData!: DashboardData 
  isQuestionnaireFilled = false;
  isQuestionnaireAvailable = false;
  tooltipReasonKey = '';
  tooltipReasonParams: Record<string, string> = {};
  isLoading = false;
  private readonly legacyDimensionTranslationMap: Record<string, string> = {
    leadership: 'report-and-results.dimension-name.leadership',
    comunicazione: 'report-and-results.dimension-name.communication',
    communication: 'report-and-results.dimension-name.communication',
    diversita: 'report-and-results.dimension-name.diversity',
    diversity: 'report-and-results.dimension-name.diversity',
    sviluppo: 'report-and-results.dimension-name.development',
    development: 'report-and-results.dimension-name.development',
    supporto: 'report-and-results.dimension-name.support',
    support: 'report-and-results.dimension-name.support'
  };

  constructor(private http: HttpClient,private route:Router, 
    private questionnaireService: QuestionnaireService, private alertService: AlertService, private translate: TranslateService) {}

  ngOnInit(): void {

    this.isLoading = true;

    this.loadDashboardData();

    this.questionnaireService.canFillQuestionnaire().subscribe(
      (res: QuestionnaireAvailability) => {
        this.isQuestionnaireAvailable = res.canFill;
        this.tooltipReasonKey = res.reason || '';
        this.tooltipReasonParams = res.reasonParams ?? {};
      },
      err => {
        console.error('Errore nel controllo disponibilità questionario:', err);
        this.isQuestionnaireAvailable = false;
        this.tooltipReasonKey = 'dashboard.questionnaire-error-check';
        this.tooltipReasonParams = {};
      }
    );

    this.questionnaireService.isCompanyQuestionnaireFilled().subscribe(filled => {
      this.isQuestionnaireFilled = filled;
    });

  }

  loadDashboardData() {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };

    this.http.get<DashboardData>(environment.apiUrl + '/api/companies/dashboard', { headers })
      .subscribe({
        next: (data) => {
          this.dashboardData = data;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Errore nel recupero dei dati del dashboard:', err);
          this.isLoading = false;
        }
      });
  }

  get progressByDimension() {
    return this.dashboardData?.selfAssessmentReport?.dimensionScores || {};
  }

  getDimensionLabelTranslationKey(dimensionName: string): string {
    const rawKey = this.dashboardData?.selfAssessmentReport?.dimensionTranslationKeys?.[dimensionName]?.trim();
    if (rawKey) {
      return rawKey.includes('.')
        ? rawKey
        : `report-and-results.dimension-name.${rawKey}`;
    }

    const normalizedDimensionName = String(dimensionName ?? '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    return this.legacyDimensionTranslationMap[normalizedDimensionName] ?? dimensionName;
  }

  ceilTwoDecimals(value: number | undefined): string {
    if (value == null) return '--';
    return (Math.ceil(value * 100) / 100).toFixed(2);
  }

  normalizeToPercentage(value: number): number {
    return ((value - 1) / 4) * 100;
  }

  getProgressColor(value: number): 'primary' | 'accent' | 'warn' {
    if (value >= 4.0) return 'primary';      
    if (value >= 3.5) return 'accent';       
    return 'warn';                          
  }

  getAverageProgress(): number {
    const scores = Object.values(this.progressByDimension);
    if (!scores.length) return 0;
    const avg = scores.reduce((sum, v) => sum + v, 0) / scores.length;
    const normalized = ((avg - 1) / 4) * 100;
    return normalized;
  }

    fillQuestionnaire() {
    if (!this.isQuestionnaireAvailable) {
      this.alertService.errorKey('dashboard.questionnaire-not-available');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    this.route.navigate(
      ['/fill-questionnaire'],
      { queryParams: { returnUrl: '/dashboard' } }
    );
  }

  inclusionLevelTranslate(): string|null|undefined {
    if (this.dashboardData.selfAssessmentReport.inclusionLevel == "Advanced")
      return "level-name.advanced"
    else if (this.dashboardData.selfAssessmentReport.inclusionLevel == "Intermediate")
      return "level-name.intermediate"
    else if (this.dashboardData.selfAssessmentReport.inclusionLevel == "Sufficient")
      return "level-name.sufficient"
    else if (this.dashboardData.selfAssessmentReport.inclusionLevel == "Insufficient")
      return "level-name.insufficient"
    else return "N/A"

    
  }


  /* fillQuestionnaire() {
    if (this.isQuestionnaireFilled === true) {
      console.log('dentro')
      this.alertService.error('You have already completed the questionnaire!')
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
          }, 13000);
    }
    else{
      this.route.navigate(
        ['/fill-questionnaire'],
        { queryParams: { returnUrl: '/dashboard' } }
      );
    }
  } */

}

